import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPackages = (packages) => ({
  type: actionTypes.SET_USER_PACKAGES,
  payload: packages
})
